import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BiSortAlt2 } from "react-icons/bi";
import { FaRupeeSign, FaPlusSquare, FaMinusSquare } from "react-icons/fa";
import styles from "../commanstyles.module.css";
import { IoMdLock } from "react-icons/io";

function Establishment({ data = [], isSubScribe }) { // <-- default value added
  const navigate = useNavigate();
  const [currency, setCurrency] = useState("Crore");
  const [toggleEstablishment, setToggleEstablishment] = useState(true);
  const [expandedRow, setExpandedRow] = useState(null); // State to track expanded row

  const convertValue = (value) => {
    switch (currency) {
      case "Lakh":
        return value * 100;
      case "Million":
        return value * 10;
      case "INR":
        return value * 10000000;
      case "Crore":
      default:
        return value;
    }
  };

  const toggleSection = (section) => {
    if (section === "Establishment") {
      setToggleEstablishment(!toggleEstablishment);
    }
  };

  const toggleRowExpansion = (establishmentId) => {
    if (expandedRow === establishmentId) {
      setExpandedRow(null); // Collapse if the same row is clicked again
    } else {
      setExpandedRow(establishmentId); // Expand the clicked row
    }
  };

  const columnHeaders = [
    "Establishment ID",
    "Establishment Name",
    "City",
    "Latest Wage Month",
    "Latest Date of Credit",
    "No. of Employees",
    "Amount (Crore)",
  ];

  const renderTable = () => (
    <>
      {isSubScribe ? (
        <table className={styles.commantable}>
          <thead>
            <tr className={styles.tableHeaderRow}>
              {columnHeaders.map((header) => (
                <th key={header} className={styles.tableHeader}>
                  {header}{" "}
                  {header !== "Establishment ID" && (
                    <BiSortAlt2 size={20} style={{ cursor: "pointer" }} />
                  )}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length > 0 ? (
              data.map((establishment) => {
                // safe defaults for nested arrays
                const epfoDetails = establishment.epfoDetails || [];
                const exemptionStatus = establishment.exemptionStatus || [];

                return (
                  <React.Fragment
                    key={establishment.establishmentId || Math.random()}
                  >
                    <tr className={styles.tableRow}>
                      <td
                        onClick={() =>
                          toggleRowExpansion(establishment.establishmentId)
                        }
                        className={styles.tableCell}
                      >
                        <div className={styles.tableCell_gstnumber}>
                          {expandedRow === establishment.establishmentId ? (
                            <FaMinusSquare />
                          ) : (
                            <FaPlusSquare />
                          )}
                          {establishment.establishmentId || "-"}
                        </div>
                      </td>
                      <td className={styles.tableCell}>
                        {establishment.establishmentName || "-"}
                      </td>
                      <td className={styles.tableCell}>
                        {establishment.city || "-"}
                      </td>
                      <td className={styles.tableCell}>
                        {establishment.latestWageMonth
                          ? new Date(establishment.latestWageMonth).toLocaleDateString(
                            "en-GB",
                            { day: "2-digit", month: "short", year: "numeric" }
                          )
                          : "-"}
                      </td>
                      <td className={styles.tableCell}>
                        {establishment.latestDateOfCredit
                          ? new Date(establishment.latestDateOfCredit).toLocaleDateString(
                            "en-GB",
                            { day: "2-digit", month: "short", year: "numeric" }
                          )
                          : "-"}
                      </td>
                      <td className={styles.tableCell}>
                        {establishment.noOfEmployees || "-"}
                      </td>
                      <td className={styles.tableCell}>
                        {establishment.amount
                          ? Number(convertValue(establishment.amount)).toLocaleString(
                            "en-IN",
                            { minimumFractionDigits: 2, maximumFractionDigits: 2 }
                          )
                          : "-"}
                      </td>
                    </tr>

                    {expandedRow === establishment.establishmentId && (
                      <tr>
                        <td colSpan="7">
                          <div className={styles.additionalData}>
                            <div className={styles.leftColumn}>
                              <div>
                                <strong>Date of Setup:</strong>{" "}
                                {establishment.dateOfSetup || "-"}
                              </div>
                              <div>
                                <strong>Principal Business Activities:</strong>{" "}
                                {establishment.principalBusinessActivities || "-"}
                              </div>
                              <div>
                                <strong>Address:</strong> {establishment.address || "-"}
                              </div>
                            </div>

                            <div className={styles.rightColumn}>
                              <div>
                                <strong>Exemption Status:</strong>{" "}
                                {exemptionStatus.length > 0
                                  ? exemptionStatus.map((status, index) => (
                                    <div key={index}>
                                      <strong>{status.type}: </strong>
                                      {status.status}
                                    </div>
                                  ))
                                  : "-"}
                              </div>
                              <div>
                                <strong>Working Status:</strong>{" "}
                                {establishment.workingStatus || "-"}
                              </div>
                            </div>
                          </div>

                          <table className={styles.commantable}>
                            <thead className={styles.tableHeaderRow}>
                              <tr>
                                <th className={styles.tableHeader}>TRRN</th>
                                <th className={styles.tableHeader}>Wage Month</th>
                                <th className={styles.tableHeader}>Date of Credit</th>
                                <th className={styles.tableHeader}>No. of Employees</th>
                                <th className={styles.tableHeader}>Amount (Crore)</th>
                              </tr>
                            </thead>
                            <tbody>
                              {epfoDetails.length > 0 ? (
                                epfoDetails.map((detail, i) => (
                                  <tr key={i}>
                                    <td>{detail.trrn || "-"}</td>
                                    <td>
                                      {detail.wageMonth
                                        ? new Date(detail.wageMonth).toLocaleDateString(
                                          "en-GB",
                                          { day: "2-digit", month: "short", year: "numeric" }
                                        )
                                        : "-"}
                                    </td>
                                    <td>
                                      {detail.dateOfCredit
                                        ? new Date(detail.dateOfCredit).toLocaleDateString(
                                          "en-GB",
                                          { day: "2-digit", month: "short", year: "numeric" }
                                        )
                                        : "-"}
                                    </td>
                                    <td>{detail.noOfEmployees || "-"}</td>
                                    <td>
                                      {detail.amount
                                        ? Number(detail.amount).toLocaleString("en-IN", {
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2,
                                        })
                                        : "-"}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="5" className={styles.noDocumentsFound}>
                                    No Principal Business Activities Available
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })
            ) : (
              <tr>
                <td colSpan={columnHeaders.length} className={styles.noDocumentsFound}>
                  No Principal Business Activities data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      ) : (
        <button className={styles.Subscription_msg} onClick={() => navigate("/kohere/mycredits", { state: { active: "BuyCredits" } })}>
          <IoMdLock /> Subscription required to view data
        </button>
      )}
    </>
  );

  return (
    <div className={styles.table_subcontainer}>
      <div className={styles.headerWithFilter}>
        {isSubScribe ? (
          <div className={styles.highlet_header_content1}>
            <p
              className={styles.minuse_icon}
              onClick={() => toggleSection("Establishment")}
            >
              {toggleEstablishment ? <FaMinusSquare size={22} /> : <FaPlusSquare size={22} />}
            </p>
            <h3 className={styles.highlet_text}>
              ESTABLISHMENTS REGISTERED WITH EPFO
            </h3>
          </div>
        ) : (
          <div className={styles.headerNoSubscription}></div>
        )}

        {toggleEstablishment && isSubScribe && data.length > 0 && (
          <div className={styles.financialdata_currency_select}>
            <div>
              <FaRupeeSign />
            </div>
            <div>
              <select
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
                className="unit-width"
              >
                <option value="Crore">Crore</option>
                <option value="Lakh">Lakh</option>
                <option value="INR">INR</option>
                <option value="" disabled>
                  --------
                </option>
                <option value="Million">Million</option>
              </select>
            </div>
          </div>
        )}
      </div>

      {toggleEstablishment && renderTable()}
    </div>
  );
}

export default Establishment;
